import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import { RailDisplayMode } from '@shared/types/enums/rail';

const EmptyCardContainer = styled.div<{ displayMode: RailDisplayMode }>`
  border: ${4 * Screen.widthRatio}px solid transparent;
  border-radius: ${20 * Screen.widthRatio}px;
  cursor: pointer;
  float: left;
  height: ${(props) =>
    (props.displayMode === RailDisplayMode.SQUARE ? 110 : 197) *
    Screen.widthRatio}px;
  margin-right: ${4 * Screen.widthRatio}px;
  overflow: hidden;
  width: ${(props) =>
    (props.displayMode === RailDisplayMode.SQUARE ? 110 : 350) *
    Screen.widthRatio}px;
  &:hover {
    border: ${4 * Screen.widthRatio}px solid white;
  }
`;

export default EmptyCardContainer;
